import { Link } from "react-router-dom";
import { NetstaffLogo } from "@/components/NetstaffLogo";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Calendar, DollarSign, Smartphone } from "lucide-react";

const benefits = [
  { icon: Calendar, title: "Flexible shifts", desc: "Choose when you work. Day, night, weekends — all yours." },
  { icon: DollarSign, title: "Competitive rates", desc: "Set your own hourly rate. Weekend and holiday premiums." },
  { icon: Smartphone, title: "Mobile-first PWA", desc: "Manage shifts, check-in, and view earnings on your phone." },
  { icon: ShieldCheck, title: "Verified network", desc: "Work with credentialed peers in trusted facilities." },
];

export default function JoinPublic() {
  return (
    <div className="min-h-screen hero-gradient py-10">
      <div className="max-w-4xl mx-auto px-6">
        <Link to="/" className="block mb-6"><NetstaffLogo /></Link>
        <h1 className="text-3xl sm:text-4xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>
          Join the NetStaff network
        </h1>
        <p className="mt-3 text-slate-600 max-w-2xl">
          Healthcare professionals in Ontario — registered nurses, PSWs, social workers, dental hygienists, and more — join us to access vetted shifts at trusted facilities.
        </p>

        <div className="mt-8 grid sm:grid-cols-2 gap-4">
          {benefits.map((b, i) => {
            const Icon = b.icon;
            return (
              <Card key={b.title} className="hover:border-brand-teal transition-colors" data-testid={`benefit-${i}`}>
                <CardContent className="p-6">
                  <div className="w-12 h-12 rounded-xl bg-brand-teal/10 flex items-center justify-center">
                    <Icon className="w-6 h-6 text-brand-teal" />
                  </div>
                  <h3 className="mt-4 font-semibold text-lg text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>{b.title}</h3>
                  <p className="text-sm text-slate-600 mt-2">{b.desc}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-10 p-8 rounded-2xl bg-brand-navy text-white">
          <h3 className="text-2xl font-bold" style={{ fontFamily: "Outfit, sans-serif" }}>Ready to start?</h3>
          <p className="mt-2 text-white/80">Create your profile in under 5 minutes.</p>
          <Link to="/register" className="inline-block mt-4">
            <Button size="lg" className="bg-brand-teal hover:bg-brand-teal/90 rounded-full px-8" data-testid="join-register-btn">
              Create my professional profile
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
